"use client";

import React from "react";
import { Clock, Code, Heart, Timer } from "lucide-react";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const statistics = [{
  id: 1,
  value: "+150%",
  label: "[ ZICHTBAAR ] MEER BEREIK DOOR STRATEGISCHE CONTENT.",
  icon: Heart
}, {
  id: 2,
  value: "10 +",
  label: "[ EFFICIËNTIE ] Bespaarde uren door AI-automatisering.",
  icon: Timer
}, {
  id: 3,
  value: "2.4x",
  label: "[ GROEI ] Stijging in conversie en leads.",
  icon: Code
}, {
  id: 4,
  value: "24/7",
  label: "[ CONNECTIE ] Altijd bereikbaar via slimme chatbots.",
  icon: Clock
}];
export default function OurImpactInNumbers() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="103431" id="onze-impact" className="dark bg-background text-foreground">
      <div className="bg-secondary/30 py-24">
        <div className="mx-auto max-w-7xl px-6">
          <div ref={ref} className={`grid grid-cols-1 gap-6 transition-all duration-1000 md:grid-cols-2 lg:grid-cols-4 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
            {statistics.map((stat, i) => {
            const Icon = stat.icon;
            return <Card key={stat.id} data-index={i} className="flex flex-col items-center justify-center border-none bg-transparent p-8 text-center transition-all duration-300 hover:bg-accent/5 shadow-none">
                  <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-full bg-accent/10">
                    <Icon className="h-6 w-6 text-primary" />
                  </div>
                  <div className="font-default text-5xl font-bold tracking-tighter text-primary">
                    {stat.value}
                  </div>
                  <div className="mt-2 font-mono text-xs text-muted-foreground uppercase tracking-widest leading-relaxed">
                    {stat.label}
                  </div>
                </Card>;
          })}
          </div>
        </div>
      </div>
    </section>;
}